import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['select', 'fieldInput', 'directionInput', 'form', 'filters', 'searchInput']

  connect() {
    $('.selectpicker').selectpicker({
      sanitizeFn: domNodes => domNodes
    })
  }

  get selectedOption() {
    const options = Array.from(this.selectTarget.options)
    return options.find(opt => opt.selected)
  }

  get selectedField() {
    return this.selectedOption.dataset.ordering_field
  }

  get selectedDirection() {
    return this.selectedOption.dataset.ordering_direction
  }

  sort() {
    this.fieldInputTarget.value = this.selectedField
    this.directionInputTarget.value = this.selectedDirection
    this.submit()
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  addFilter(select_html) {
    const existingSelect = this.filtersTarget.querySelector(`[data-filter="${select_html.dataset.filter}"]`)
    if (existingSelect) existingSelect.remove()
    this.filtersTarget.appendChild(select_html)
  }

  search() {
    if (event.target.value && event.target.value.length < 3) {
      return
    }
    setTimeout(() => {
      this.submit()
    }, 500)
  }
}
